import { Component } from '@angular/core';

@Component({
  templateUrl: 'viewparameter.component.html'
})
export class ViewparameterComponent {

  constructor() { 

  } 
}


// WEBPACK FOOTER //
// ./src/app/systems/viewparameter.component.ts